module.exports = __webpack_public_path__ + "static/img/gaozhongshengwu2.295b348a.jpg";